import {
  Component,
  OnInit,
  Input,
  NgZone,
  Output,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';
import { LoginService } from '../home/login.service';
import { ICartItems } from '../onlineorder/cartitems';
import { OnlineOrderService } from '../onlineorder/onlineorder.service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { AppComponent } from '../app.component';
import { Subscription, switchMap, tap, catchError, of, EMPTY  } from 'rxjs';
import { ProductService } from '../products/products.service';
import { ToastrService } from 'ngx-toastr';
import { OrderService } from '../onlineorder/order.service';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from '../admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ILatestOnlineOrder } from '../onlineorder/latestonlineorder';

@Component({
  standalone: false,
  selector: 'shopcart',
  templateUrl: './cart.component.html',
})
export class CartComponent implements OnInit {
  public pageTitle: string = 'Your Shopping Cart';
  public subTotal: number = 0;
  @Input() public checkoutClicked = false;
  public latestOrder: ILatestOnlineOrder;
  public tax: number = 0;
  public total: number = 0;
  private sub!: Subscription;
  popUpHtml: string = '<div>Please scroll below to checkout' + '</div>';
  cartItems!: ICartItems[];
  public caption: string;
  public transErrMsg: string;
  translatedText = '';

  constructor(
    private _loginService: LoginService,
    private orderService: OrderService,
    private onlineorder: OnlineOrderService,
    private router: Router,
    private app: AppComponent,
    private change: ChangeDetectorRef,
    private _route: ActivatedRoute,
    private _productService: ProductService,
    private toaster: ToastrService,
    private zone: NgZone,
    public translate: TranslateService,
    public admin: AdminService,
    public spinner: NgxSpinnerService
  ) {}

  getLocale(): any {
    var currentLocale = localStorage.getItem('locale');
    return currentLocale;
  }
  googleTranslateCall(textToTrans: string, targetLang: string): string {
    let model = {
      q: [textToTrans],
      target: targetLang,
    };
    this.admin.googleTranslate(model).subscribe((response: any) => {
      //console.log('Translate Call: ' + response.data.translations[0].translatedText);
      this.translatedText = response.data.translations[0].translatedText;
      return this.translatedText;
    });
    return '';
  }
  showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
    //use this for dynamic error messages
    if (staticErrorMsg === false) {
      let locale = this.getLocale();
      if (locale !== 'en') {
        //were gonna do it nested, couldn't do it as a standalone method.
        let model = {
          q: [errorMessage],
          target: locale,
        };

        this.admin.googleTranslate(model).subscribe(
          (response: any) => {
            let res = response.data.translations[0].translatedText as string;
            this.translatedText = response.data.translations[0]
              .translatedText as string;
            this.transErrMsg = this.translatedText;
            localStorage.setItem('translatedText', res);
          },
          (error) => console.log(error),
          () => {
            this.translate.get(subject).subscribe(
              (res: string) => {
                this.caption = res;
                console.log(res);
              },
              (error) => console.log(error),
              () => {
                this.spinner.hide();
                //once the caption is translated, fire off the toaster popup
                this.toaster.error(this.transErrMsg, this.caption, {
                  timeOut: 5000,
                });
                localStorage.removeItem('translatedText');
              }
            );
          }
        );

        //this.transErrMsg =  this.translatedText;
      } else {
        this.translate.get(subject).subscribe(
          (res: string) => {
            this.caption = res;
            console.log(res);
          },
          (error) => console.log(error),
          () => {
            this.transErrMsg = errorMessage;
            this.spinner.hide();
            //once the caption is translated, fire off the toaster popup
            this.toaster.error(this.transErrMsg, this.caption, {
              timeOut: 5000,
            });
            localStorage.removeItem('translatedText');
          }
        );
      }
    } else {
      // translate the error message - not dynamic
      this.translate.get(errorMessage).subscribe((res: string) => {
        this.transErrMsg = res;
        console.log(res);
      });

      // translate the caption
      this.translate.get(subject).subscribe((res: string) => {
        this.caption = res;
        console.log(res);
      });
      this.spinner.hide();
      //show the toaster popup
      this.toaster.error(this.transErrMsg, this.caption, {
        timeOut: 5000,
      });
    }
  }
  clearCart() {
    if (this._loginService.loggedIn()) {
      this.cartItems = [];
      this.app.myProdCount = 0;
      this.subTotal = 0;
      this.tax = 0;
      this.total = 0;
      localStorage.removeItem('cartItems');
      this.orderService.clearCart(false);
      this.orderService.cart = [];
      this.orderService.tempCart = [];
      //this.orderService.updateShipMethodPlusTotals().subscribe();
      this.calcTax();
      this.calcTotal();

      localStorage.removeItem('prodCount');
    } else {
      this.cartItems = [];
      this.orderService.tempCart = [];
      localStorage.removeItem('cartItems');
      this.orderService.cart = [];
      this.app.myProdCount = 0;
      this.subTotal = 0;
      this.tax = 0;
      this.total = 0;
      this.calcTax();
      this.calcTotal();
      localStorage.removeItem('prodCount');
    }
  }
  public calcTax(): any {
    this.tax = 0;
    if (this._loginService.loggedIn()) {
      //this.orderService.updateShipMethodPlusTotals().subscribe();

      var currentOrderInfo = JSON.parse(
        localStorage.getItem('orderInfo') || '{}'
      );
      //this.orderID = currentOrderInfo.BalanceDue;
      // if(currentOrderInfo.totalTaxField !== undefined)
      // {
      //     this.tax = currentOrderInfo.totalTaxField;
      //     return this.tax;
      // }
      // else{
      this.tax = currentOrderInfo.TaxTotal;
      return this.tax;
      //}
    } else {
      this.cartItems = this.orderService.getCart();
      this.tax = 0;

      return this.tax;
    }
  }
  public calcSub(): any {
    this.cartItems = this.orderService.getCart();
    this.subTotal = 0;

    for (var i = 0; i < this.cartItems.length; i++) {
      this.subTotal += this.cartItems[i].Quantity * 8.0;
    }
    return this.subTotal;
  }
  public calcTotal(): any {
    this.total = 0;
    if (this._loginService.loggedIn()) {
      //this.orderService.updateShipMethodPlusTotals().subscribe();

      var currentOrderInfo = JSON.parse(
        localStorage.getItem('orderInfo') || '{}'
      );
      //this.orderID = currentOrderInfo.BalanceDue;
      // if(currentOrderInfo.balanceDueField !== undefined)
      // {
      //     //this.subTotal = currentOrderInfo.balanceDueField;
      //     return currentOrderInfo.balanceDueField;
      // }
      // else{
      //this.subTotal = currentOrderInfo.BalanceDue;
      this.total = currentOrderInfo.BalanceDue;
      return this.total;
      //}
    } else {
      this.cartItems = this.orderService.getCart();
      this.total = 0;

      for (var i = 0; i < this.cartItems.length; i++) {
        this.total += this.cartItems[i].Quantity * 8.0;
      }

      return this.total;
    }
  }

  repId(): any {
    var currentId = localStorage.getItem('repId');
    return currentId;
  }
  continueShopping() {
    this.clearCart();
    this.router.navigateByUrl('/shop/from/' + this.repId());
  }
  checkout() {
    if (this._loginService.loggedIn() && this.total > 0) {
      if (this.cartItems.length === 1) {
        this.checkoutClicked = true;
        this.scrollDown('shoppingCart.checkout.toastPopup.info.scrollDown');
        this.router.navigateByUrl('/checkout/from/' + this.repId());
      } else {
        localStorage.removeItem('cartItems');
        this.orderService.clearCart(false);
        this.showError(
          'shoppingCart.checkout.toastPopup.errors.tooManyItems',
          'shoppingCart.checkout.toastPopup.title.tooManyItems',
          true
        );
      }
    } else if (this._loginService.loggedIn() && this.total == 0) {
      this.continueShopping();
    } else {
        const returnUrl = this.router.url; // or '/checkout'
        this.router.navigate(['/login'], { queryParams: { returnUrl } });
    }
  }

  scrollDown(message: string): void {
    this.translate.get(message).subscribe((res: string) => {
      this.transErrMsg = res;
      console.log(res);
    });

    this.toaster.show('<div>' + this.transErrMsg + '</div>', '', {
      timeOut: 3000,
      enableHtml: true,
    });
  }
  // createError(): void {

  //     this.toaster.error("There were too many items in your cart, please make another free sample selection.", "Error", {
  //         timeOut: 3000
  //     });
  // }

  // balanceDueGreaterThanTenError(): void {

  //     this.toaster.error("It looks like you were working on another order along with this sample order. "
  //         + "For your convenience we have cleared your cart to prevent order duplication. You can now select your Free Sample Set", "Error", {
  //     });
  // }

  ngAfterViewInit() {
    this.change.detectChanges();
  }
ngOnInit(): void {
  this.sub = this._route.params.subscribe((params) => {
    let id = +params['id'];
    this._productService.getRepInfo(id.toString()).subscribe((rep) => {
      this.app.rep = rep;
    });
    localStorage.setItem('repId', id.toString());
  });

  var newCount = localStorage.getItem('prodCount');
  this.app.myProdCount = Number(newCount);

  var myCart = JSON.parse(localStorage.getItem('cartItems') || '{}');
  if (myCart !== null && Array.isArray(myCart)) {
    this.orderService.cart = myCart;
    this.cartItems = myCart;
  } else {
    this.cartItems = this.orderService.getCart();
  }

  // existing >$10 guard
  if (this.calcTotal() > 10) {
    this.clearCart();
    this.showError(
      'shoppingCart.checkout.toastPopup.errors.greaterThanTen',
      'shoppingCart.checkout.toastPopup.title.tooManyItems',
      true
    );
    this.zone.run(() => {
      setTimeout(() => {
        this.app.myRepID = this.repId();
        this.router.navigateByUrl('shop/from/' + this.repId());
      }, 10000);
    });
    return;
  }

  if (this._loginService.loggedIn() && this.app.myProdCount > 0) {
    this.onlineorder.latestOnlineOrder(true).pipe(
      tap((data: ILatestOnlineOrder) => {
        localStorage.setItem('orderId', JSON.stringify(data));
        this.latestOrder = data;
      }),
      switchMap((data: ILatestOnlineOrder) => {
        const serverCount = data?.Items?.length ?? 0;
        const localCount  = this.cartItems?.length ?? 0;

        // local cart has items but server order is empty → stale localStorage from a prior session
        if (localCount > 0 && serverCount === 0) {
          this.handleStaleCart();
          return EMPTY; // stop the pipeline
        }
        return this.onlineorder.calculateTax();
      }),
      switchMap(() => this.orderService.updateShipMethodPlusTotals2()),
      tap((value) => localStorage.setItem('orderInfo', JSON.stringify(value))),
      catchError((err) => {
        console.error('[CART INIT] totals pipeline failed', err);
        return of(null);
      })
    ).subscribe();
  }
}

private handleStaleCart(): void {
  console.warn('[CART INIT] local cart out of sync with server order — clearing');
  this.clearCart();
  this.showError(
    'shoppingCart.checkout.toastPopup.errors.orderOutOfSync',
    'shoppingCart.checkout.toastPopup.title.tooManyItems',
    true
  );
  this.zone.run(() => {
    setTimeout(() => {
      this.router.navigateByUrl('/shop/from/' + this.repId());
    }, 3000);
  });
}

  ngOnInitOLD(): void {
    // if(this._loginService.refresh_token == undefined || this._loginService.refresh_token == null)
    // {
    //     localStorage.removeItem('authorizationData');
    //     this._loginService.isAuthenticated = false;
    //     this.app.loggedIn = false;
    // }
    this.sub = this._route.params.subscribe((params) => {
      let id = +params['id'];
      this._productService.getRepInfo(id.toString()).subscribe((rep) => {
        //this.rep = rep;
        this.app.rep = rep;
      });
      localStorage.setItem('repId', id.toString());
    });

    // if (this._loginService.loggedIn()) {
    //     this._loginService.refreshToken()
    //         .subscribe();
    // }
    var newCount = localStorage.getItem('prodCount');

    // master product count throughout the application.
    this.app.myProdCount = Number(newCount);

    var myCart = JSON.parse(localStorage.getItem('cartItems') || '{}');
    if (myCart !== null) {
      this.orderService.cart = myCart;
      this.cartItems = myCart;
    } else {
      this.cartItems = this.orderService.getCart();
    }

    if (this.calcTotal() > 10) {
      this.clearCart();
      this.showError(
        'shoppingCart.checkout.toastPopup.errors.greaterThanTen',
        'shoppingCart.checkout.toastPopup.title.tooManyItems',
        true
      );

      this.zone.run(() => {
        setTimeout((router: Router) => {
          this.app.myRepID = this.repId();
          this.router.navigateByUrl('shop/from/' + this.repId());
        }, 10000);
      });
    }

    if (this._loginService.loggedIn()) {
      // if item - and taxes are 0 - run calculation and update shiptotals
      if (this.app.myProdCount > 0) {
        // i think we should update the latest online order here and store it.

        this.onlineorder.latestOnlineOrder(true).subscribe({
          next: (data: ILatestOnlineOrder) => {
              //overwrite with new information.
               localStorage.setItem('orderId', JSON.stringify(data));
          },
          complete: () => {
            this.onlineorder.calculateTax().subscribe(
              (thing2) => thing2,
              (error) => console.log(error),
              () => {
                this.orderService.updateShipMethodPlusTotals2().subscribe({
                  next(value) {
                    localStorage.setItem('orderInfo', JSON.stringify(value));
                  },
                });
              }
            );
          },
        });
      }
    }
  }
}
